import { useState, useEffect } from 'react';
import enUS from 'antd/lib/locale/en_US';
import { languagesConfig } from '~/utils/i18n';
import { Locale } from 'antd/lib/locale-provider';

export function useAntdLocale(language: string) {
  const [locale, setLocale] = useState<Locale>(enUS); // we should use locale by default otherwise antd returns errors
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const loadLocale = async () => {
      setLoading(true);
      try {
        const module = await languagesConfig[language].antdLocale();
        setLocale(module.default);
      } catch (err) {
        setLocale(enUS);
      } finally {
        setLoading(false);
      }
    };

    loadLocale();
  }, [language]);

  return { locale, loading };
}
